import { createSlice } from "@reduxjs/toolkit";
import { fetchReportsMinistriesMappingList } from "./reportsMappingApi";

interface ReportsMappingState {
    reportsMinistries: any[];
    isLoading: boolean;
    error: any;
}

const initialState: ReportsMappingState = {
    reportsMinistries: [],
    isLoading: false,
    error: null
}

const reportsMinMappingSlice = createSlice({
    name: "reportsMinistryMapping",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReportsMinistriesMappingList.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchReportsMinistriesMappingList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.reportsMinistries = action?.payload?.data || [];
            })
            .addCase(fetchReportsMinistriesMappingList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error?.message || 'Something went wrong';
            })
    }
});

export default reportsMinMappingSlice.reducer;